export const TiebreakerCondition = {
  TOTAL_GAMES: "TOTAL_GAMES",
  CHAMPIONSHIP_POINTS: "CHAMPIONSHIP_POINTS",
};
